<section>

  <div class="container-one">
    <div class=" curve top-left-curve"></div>

    <div class="content">
      <h3>Welcome!</h3>

      <p>Streamlining school management for a brighter future.</p>

      <img src="/auth/teacher-student.png" alt="teacher teaching student">
    </div>

    <div class=" curve bottom-right-curve"></div>
  </div>

  <div class="container-two">
    <img class="school-logo" [src]="schoolImage() === null ? '/auth/graduate.svg' : schoolImage()" alt="">

    <h3>{{ schoolName() }}</h3>

    <div class="note">

      <div class="shield-box"><img src="/auth/shield-image.png" alt="shield image"></div>

      <div>
        <h6>First Time Login Requirement</h6>
        <p>You are logging in with a temporary password. For security compliance, please update your account password
          before proceeding.</p>
      </div>
    </div>

    <form #setPasswordForm="ngForm" (ngSubmit)="setPassword(setPasswordForm)">
      <div class="form-group">
        <label for="temporaryPassword">Temporary Password</label>
        <input required [(ngModel)]="temporaryPassword" [type]="showTempPassword ? 'text' : 'password'"
               name="temporaryPassword" id="temporaryPassword" placeholder="Enter temporary password from admin">

        <button type="button" class="toggle-password" (click)="showTempPassword = !showTempPassword">
          @if (!showTempPassword) {
            <img src="/auth/eye-icon.svg" alt="eye icon">
          } @else {
            <img src="/auth/eye-slash.svg" alt="eye slash icon">
          }
        </button>
      </div>

      <div class="form-group">
        <label for="newPassword">New Password</label>
        <input required [(ngModel)]="newPassword" [type]="showNewPassword ? 'text' : 'password'" name="newPassword"
               id="newPassword" placeholder="Enter a new password">

        <button type="button" class="toggle-password" (click)="showNewPassword = !showNewPassword">
          @if (!showNewPassword) {
            <img src="/auth/eye-icon.svg" alt="eye icon">
          } @else {
            <img src="/auth/eye-slash.svg" alt="eye slash icon">
          }
        </button>
      </div>

      <div class="form-group">
        <label for="confirmPassword">Retype Password</label>
        <input required [(ngModel)]="confirmPassword" [type]="showConfirmPassword ? 'text' : 'password'"
               name="confirmPassword" id="confirmPassword" placeholder="Retype your password">

        <button type="button" class="toggle-password" (click)="showConfirmPassword = !showConfirmPassword">
          @if (!showConfirmPassword) {
            <img src="/auth/eye-icon.svg" alt="eye icon">
          } @else {
            <img src="/auth/eye-slash.svg" alt="eye slash icon">
          }
        </button>
      </div>

      <div class="password-req"
           [class.success-box]="newPassword.length >= 8 &&
            newPassword !== temporaryPassword &&
            (/\d/.test(this.newPassword)) &&
            (/[!@#$%^&*]/.test(this.newPassword))">

        <h6>Password Requirements</h6>

        <ul>
          <li [class.success]="newPassword.length >= 8 &&
            newPassword !== temporaryPassword
">
            <div><img src="/auth/checkbox.png" alt="checkbox icon"></div>
            <small>Minimum 8 characters</small>
          </li>

          <li [class.success]="newPassword !== temporaryPassword && newPassword.length >= 8">
            <div><img src="/auth/checkbox.png" alt="checkbox icon"></div>
            <small>New password cannot be same as temporary password</small>
          </li>

          <li [class.success]="newPassword !== temporaryPassword && newPassword.length >= 8 && (/\d/.test(this.newPassword))">
            <div><img src="/auth/checkbox.png" alt="checkbox icon"></div>
            <small>At least 1 numeric digit (0-9)</small>
          </li>

          <li [class.success]="newPassword !== temporaryPassword && newPassword.length >= 8 && (/\d/.test(this.newPassword) && (/[!@#$%^&*]/.test(this.newPassword)))">
            <div><img src="/auth/checkbox.png" alt="checkbox icon"></div>
            <small>At least 1 special character (!&#64;#$%^&*)</small>
          </li>

        </ul>
      </div>

      <div class="btn-container">
        <button [disabled]="setPasswordForm.invalid ||
                (confirmPassword === temporaryPassword) ||
                (newPassword === temporaryPassword) ||
                (newPassword !== confirmPassword) ||
                (confirmPassword.length < 8) ||
                (newPassword.length < 8)"
                type="submit" class="button">
          @if (isLoading()) {
            <app-loading-indicator></app-loading-indicator>
          } @else {
            Confirm
          }
        </button>
      </div>

    </form>
  </div>
</section>
